import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';
import { AddBillingitemsWizardDataV26Service } from 'src/app/services-v26/wizards/add-billingitems-wizard-v26.service';
import * as MoveBillingitemsWizardActions from './actions';
import { selectInitStep } from './selectors';
import { State } from './state';

@Injectable()
export class MoveBillingitemsWizardEffectsV26 {
  // loadMoveProductWizards$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(MoveBillingitemsWizardActions.selectInitStep),
  //       tap(() => this.router.navigateByUrl('/pages/allocation-wizards/order'))
  //     ),
  //   { dispatch: false }
  // );
  // exitMoveBillingitemsAllocationWizards$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(MoveBillingitemsWizardActions.exitAllocationMoveBillingitemsWizard),
  //       tap(() => this.router.navigateByUrl('/pages/consumers'))
  //     ),
  //   { dispatch: false }
  // );

  newMoveBillingitems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MoveBillingitemsWizardActions.createNewMoveBillingitems),
      withLatestFrom(this.store.select(selectInitStep)),
      concatMap(([{ request }, initStep]) =>
        this.addBillingitemsWizardService.moveBillingitems(request).pipe(
          map((response) => {
            if (response) {
              return MoveBillingitemsWizardActions.createNewMoveBillingitemsSuccess({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(MoveBillingitemsWizardActions.createNewMoveBillingitemsFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private addBillingitemsWizardService: AddBillingitemsWizardDataV26Service,
  ) {}
}
